import { getNextPreviousCard } from "@modules/tracking/previous-next-advert-cookie.ts"

export function storeLastScrollPositionAzm() {
    const possibleCardElementsCenter = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight / 2)
    const possibleCardElementsTop = document.elementsFromPoint(window.innerWidth / 2, 50)
    const possibleCardElementsBottom = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight - 50)
    const nextPrevCenter = getNextPreviousCard(possibleCardElementsCenter)
    const nextPrevTop = getNextPreviousCard(possibleCardElementsTop)
    const nextPrevBottom = getNextPreviousCard(possibleCardElementsBottom)
    const prevNextId = (nextPrevBottom || nextPrevCenter || nextPrevTop)?.getAttribute("data-next-previous-id")
    if (prevNextId) {
        localStorage.setItem(
            "scrollingLastPrevNextCard",
            JSON.stringify({ prevNextId, block: nextPrevBottom ? "end" : nextPrevCenter ? "center" : "start" }),
        )
    } else {
        localStorage.removeItem("scrollingLastPrevNextCard")
    }
}
